// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ca72cdbb","703":"b43aaf95","787":"d1d4a2c2"}[chunkId] + ".chunk.js";
};